import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, NgZone, OnInit, QueryList, Renderer2, ViewChild, ViewChildren } from '@angular/core';
import { NavigationStart, PRIMARY_OUTLET, Router, Event as RouterEvent } from '@angular/router';

import { WrapperService } from '../wrapper/wrapper.service';
import { HeaderService } from '../header/header.service';

import { LayoutStore } from '../layout.store';

import { AnimationEvent } from '../../animations/animations.interface';

import { SidebarLeftToggleDirective } from './sidebar-left.directive';

export interface Item {
  id: number;
  parentId: number;
  label: string;
  route?: string;
  iconClasses?: string;
  children?: Array<Item>;
  isActive?: boolean;
  isCollapsed?: boolean;
}

export type Items = Array<Item>;
export class SidebarLeftComponent implements OnInit, AfterViewInit {
public menu: Array<any>;
public sidebarStyles: any;
public sidebarHeight: number;
public sidebarOverflow: string;
private layout: string;
private isSidebarLeftCollapsed: boolean;
private isSidebarLeftExpandOnOver: boolean;
private isSidebarLeftMouseOver: boolean;
private windowInnerWidth: number;
private windowInnerHeight: number;
private collapsedItems: Items = [];
private activatedItems: Items = [];
private toggleListeners: Array<Function>;
private itemsByIds: {[propKey: number]: Item} = {};
private runningAnimations = 0;
public sidebarElement: ElementRef;
public sidebarLeftToggleDirectives: QueryList<SidebarLeftToggleDirective>;
/**
 * \@method constructor
 * @param {?} changeDetectorRef
 * @param {?} layoutStore
 * @param {?} ngZone
 * @param {?} renderer2
 * @param {?} router
 * @param {?} wrapperService
 * @param {?} headerService
 */
constructor(
private changeDetectorRef: ChangeDetectorRef,
private layoutStore: LayoutStore,
private ngZone: NgZone,
private renderer2: Renderer2,
private router: Router,
private wrapperService: WrapperService,
private headerService: HeaderService
  ) {}
/**
 * \@method ngOnInit
 * @return {?}
 */
ngOnInit() {
    this.setMenuListeners();
    this.setSidebarListeners();
  }
/**
 * \@method ngAfterViewInit
 * @return {?}
 */
ngAfterViewInit() {
    this.setMenuTogglesListeners();
    this.checkMenuWithoutChildren();
  }
/**
 * [setSidebarListeners description]
 * \@method setSidebarListeners
 * @return {?}
 */
setSidebarListeners(): void {
    this.layoutStore.layout.subscribe((value: string) => {
      this.layout = value;
      this.setSidebarHeight();
    });

    this.layoutStore.windowInnerHeight.subscribe((value: number) => {
      this.windowInnerHeight = value;
      this.setSidebarHeight();
    });

    this.ngZone.runOutsideAngular(() => {
      this.renderer2.listen(this.sidebarElement.nativeElement, 'mouseenter', (event: Event) => {
        this.layoutStore.sidebarLeftMouseOver(true);
      });
      this.renderer2.listen(this.sidebarElement.nativeElement, 'mouseleave', (event: Event) => {
        this.layoutStore.sidebarLeftMouseOver(false);
      });
    });

    this.layoutStore.windowInnerWidth.subscribe((value: number) => {
      this.windowInnerWidth = value;
      if(!this.isSidebarLeftCollapsed && this.windowInnerWidth <= 767) {
        this.layoutStore.sidebarLeftCollapsed(true);
      } else if(this.windowInnerWidth > 767 && this.isSidebarLeftCollapsed && !this.isSidebarLeftExpandOnOver) {
        this.layoutStore.sidebarLeftCollapsed(false);
      }
    });

    this.layoutStore.isSidebarLeftMouseOver.subscribe((value: boolean) => {
      this.isSidebarLeftMouseOver = value;
      if(this.isSidebarLeftExpandOnOver) {
        this.layoutStore.sidebarLeftCollapsed(!value);
      }
    });

    this.layoutStore.isSidebarLeftExpandOnOver.subscribe((value: boolean) => {
      this.isSidebarLeftExpandOnOver = value;
      if(this.windowInnerWidth > 767) {
        this.layoutStore.sidebarLeftCollapsed(value);
      }
    });

    this.layoutStore.isSidebarLeftCollapsed.subscribe((value: boolean) => {
      if(this.windowInnerWidth <= 767) {
        if(value) {
          this.renderer2.removeClass(this.wrapperService.wrapperElementRef.nativeElement, 'sidebar-open');
        } else {
          this.renderer2.addClass(this.wrapperService.wrapperElementRef.nativeElement, 'sidebar-open');
        }
      } else {
        if(this.isSidebarLeftExpandOnOver && !this.isSidebarLeftMouseOver && !value) {
          this.layoutStore.sidebarLeftExpandOnOver(false);
        }
        if(value) {
          this.renderer2.addClass(this.wrapperService.wrapperElementRef.nativeElement, 'sidebar-collapse');
          if(this.isSidebarLeftExpandOnOver) {
            this.renderer2.removeClass(this.wrapperService.wrapperElementRef.nativeElement, 'sidebar-expanded-on-hover');
          }
        } else {
          this.renderer2.removeClass(this.wrapperService.wrapperElementRef.nativeElement, 'sidebar-collapse');
          if(this.isSidebarLeftExpandOnOver) {
            this.renderer2.addClass(this.wrapperService.wrapperElementRef.nativeElement, 'sidebar-expanded-on-hover');
          }
        }
      }
    });

    this.layoutStore.isSidebarLeftMini.subscribe((value: boolean) => {
      if(value) {
        this.renderer2.addClass(this.wrapperService.wrapperElementRef.nativeElement, 'sidebar-mini');
      } else {
        this.renderer2.removeClass(this.wrapperService.wrapperElementRef.nativeElement, 'sidebar-mini');
      }
    });
  }
/**
 * [setMenuListeners description]
 * \@method setMenuListeners
 * @return {?}
 */
setMenuListeners() {
    this.router.events.subscribe((event: RouterEvent) => {
      if(event instanceof NavigationStart) {
        if(event.url === '/') {
          this.activeItems(event.url);
          this.changeDetectorRef.detectChanges();
        } else {
          let /** @type {?} */ primaryOutlet = this.router.parseUrl(event.url).root.children[PRIMARY_OUTLET];
          if(primaryOutlet) {
            this.activeItems(primaryOutlet.toString());
            this.changeDetectorRef.detectChanges();
          }
        }
        if(this.windowInnerWidth <= 767 || this.isSidebarLeftExpandOnOver) {
          this.layoutStore.sidebarLeftCollapsed(true);
        }
      }
    });

    this.layoutStore.sidebarLeftMenu.subscribe(value => {
      this.menu = value;
      this.monkeyPatchMenu(this.menu);
    });
  }
/**
 * [getIconClasses description]
 * \@method getIconClasses
 * @param {?} item
 * @return {?}
 */
public getIconClasses(item: Item): string {
    if(item.iconClasses || item.iconClasses === '') {
      return item.iconClasses;
    } else {
      return 'fa fa-circle-o';
    }
  }
/**
 * [visibilityStateStart description]
 * \@method visibilityStateStart
 * @param {?} event
 * @return {?}
 */
public visibilityStateStart(event: AnimationEvent): void {
    this.runningAnimations ++;
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        this.runningAnimations --;
        if(!this.runningAnimations) {
          this.layoutStore.setSidebarLeftElementHeight(this.sidebarElement.nativeElement.offsetHeight);
        }
      }, event.totalTime);
    });
  }
/**
 * [uncollapseItemParents description]
 * \@method uncollapseItemParents
 * @param {?} item
 * @param {?=} isActive
 * @return {?}
 */
private uncollapseItemParents(item: Item, isActive = false): void {
    if(isActive) {
      item.isActive = true;
    }
    item.isCollapsed = false;
    this.collapsedItems.push(item);
    if(item.parentId) {
      this.uncollapseItemParents(this.itemsByIds[item.parentId], isActive);
    }
  }
/**
 * [findItemsByUrl description]
 * \@method findItemsByUrl
 * @param {?} url
 * @param {?} items
 * @param {?=} returnItems
 * @return {?}
 */
private findItemsByUrl(url: string, items: Items, returnItems: Items = []): Items {
    items.forEach((item: Item) => {
      if(item.route === url) {
        returnItems.push(item);
      } else if (item.children) {
        this.findItemsByUrl(url, item.children, returnItems)
      }
    });
    return returnItems;
  }
/**
 * [activeItems description]
 * \@method activeItems
 * @param {?} url
 * @return {?}
 */
private activeItems(url: string): void {
    this.activatedItems.forEach((item: Item) => {
      item.isActive = false;
    });
    this.activatedItems = [];

    this.collapsedItems.forEach((item: Item) => {
      item.isActive = false;
      item.isCollapsed = true;
    });
    this.collapsedItems = [];

    let /** @type {?} */ items = this.findItemsByUrl(url, this.menu);
    items.forEach(item => {
      item.isActive = true;
      this.uncollapseItemParents(item, true);
      this.activatedItems.push(item);
    });
  }
/**
 * [monkeyPatchMenu description]
 * \@method monkeyPatchMenu
 * @param {?} items
 * @param {?=} parentId
 * @return {?}
 */
private monkeyPatchMenu(items: Items, parentId?: number): void {
    items.forEach((item: Item, index: number) => {
      item.id = parentId ? Number(parentId + '' + index) : index;
      if(parentId) {
        item.parentId = parentId;
      }
      item.isCollapsed = true;
      item.isActive = false;
      if(parentId || item.children) {
        this.itemsByIds[item.id] = item;
      }
      if(item.children) {
        this.monkeyPatchMenu(item.children, item.id);
      }
    });
  }
/**
 * [removeListeners description]
 * \@method removeListeners
 * @return {?}
 */
private removeListeners(): void {
    if(this.toggleListeners) {
      this.toggleListeners.forEach((listener: Function) => {
        listener();
      });
    }
    this.toggleListeners = [];
  }
/**
 * [setMenuTogglesListeners description]
 * \@method setMenuTogglesListeners
 * @return {?}
 */
private setMenuTogglesListeners(): void {
    this.ngZone.runOutsideAngular(() => {
      this.removeListeners();
      this.sidebarLeftToggleDirectives.forEach((menuToggle: SidebarLeftToggleDirective) => {
        this.toggleListeners.push(this.renderer2.listen(menuToggle.elementRef.nativeElement, 'click', (event) => {
          event.preventDefault();
          if(menuToggle.item.isCollapsed) {
            this.collapsedItems.forEach((item: Item) => {
              item.isCollapsed = true;
            });
            this.collapsedItems = [];
            this.uncollapseItemParents(menuToggle.item);
          } else {
            menuToggle.item.isCollapsed = !menuToggle.item.isCollapsed;
          }
          this.changeDetectorRef.detectChanges();
        }));
      });
    });
  }
/**
 * [checkMenuWithoutChildren description]
 * \@method checkMenuWithoutChildren
 * @return {?}
 */
private checkMenuWithoutChildren(): void {
    let /** @type {?} */ menuHaveChildren;
    this.menu.forEach((item: Item) => {
      if(item.children) {
        return menuHaveChildren = true;
      }
    });
    if(!menuHaveChildren) {
      this.ngZone.runOutsideAngular(() => {
        setTimeout(() => {
          this.layoutStore.setSidebarLeftElementHeight(this.sidebarElement.nativeElement.offsetHeight);
        });
      });
    }
  }
/**
 * [setSidebarHeight description]
 * \@method setSidebarHeight
 * @return {?}
 */
private setSidebarHeight(): void {
    if(this.layout === 'fixed') {
      let /** @type {?} */ height = this.windowInnerHeight - this.headerService.offsetHeight;
      if(height && height !== this.sidebarHeight) {
        this.sidebarHeight = height;
        this.sidebarOverflow = 'auto';
        this.changeDetectorRef.detectChanges();
      }
    } else if(this.sidebarHeight) {
      this.sidebarOverflow = this.sidebarHeight = null;
      this.changeDetectorRef.detectChanges();
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mk-layout-sidebar-left',
  template: `
    <aside class="main-sidebar">
      <section class="sidebar" #sidebarElement [style.height.px]="sidebarHeight" [style.overflow]="sidebarOverflow">
        <ng-content></ng-content>
      	<ul class="sidebar-menu">
          <ng-container *ngFor="let item of menu">
            <ng-container *ngTemplateOutlet="sidebarInner; context: {item: item}"></ng-container>
          </ng-container>
      	</ul>
      </section>
    </aside>

    <ng-template #sidebarInner let-item="item">
      <li [class.active]="item.isActive" [class.header]="item.separator" [class.menu-open]="!item.isCollapsed">
        <span *ngIf="item.separator">{{item.label}}</span>
        <a *ngIf="!item.separator && item.route" [routerLink]="item.route">
        	<i [class]="getIconClasses(item)"></i><span>{{item.label}}</span>
        	<span *ngIf="item.children || item.pullRights" class="pull-right-container">
        		<span *ngFor="let rightItem of item.pullRights" class="pull-right {{rightItem.classes}}">{{rightItem.text}}</span>
        	  <i *ngIf="!item.pullRights" class="fa fa-angle-left pull-right"></i>
        	</span>
        </a>
        <a *ngIf="!item.separator && !item.route" href="#" [mkMenuToggle]="item">
        	<i [class]="getIconClasses(item)"></i><span>{{item.label}}</span>
        	<span *ngIf="item.children || item.pullRights" class="pull-right-container">
        		<span *ngFor="let rightItem of item.pullRights" class="pull-right {{rightItem.classes}}">{{rightItem.text}}</span>
        	  <i *ngIf="!item.pullRights" class="fa fa-angle-left pull-right"></i>
        	</span>
        </a>
        <ul *ngIf="item.children" [collapseAnimation]="item.isCollapsed" (collapseAnimation.start)="visibilityStateStart($event)" class="treeview-menu">
          <ng-container *ngFor="let item of item.children">
            <ng-container *ngTemplateOutlet="sidebarInner; context: {item: item}"></ng-container>
          </ng-container>
        </ul>
      </li>
    </ng-template>
  `,
  styles: [`
    .main-sidebar {
      overflow: hidden;
    }

    .treeview-menu.collapse {
      display: none;
    }

    .treeview-menu,
    .treeview-menu.collapse.in {
      display: block;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ChangeDetectorRef, },
{type: LayoutStore, },
{type: NgZone, },
{type: Renderer2, },
{type: Router, },
{type: WrapperService, },
{type: HeaderService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'sidebarElement': [{ type: ViewChild, args: ['sidebarElement', ] },],
'sidebarLeftToggleDirectives': [{ type: ViewChildren, args: [SidebarLeftToggleDirective, ] },],
};
}

function SidebarLeftComponent_tsickle_Closure_declarations() {
/** @type {?} */
SidebarLeftComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
SidebarLeftComponent.ctorParameters;
/** @type {?} */
SidebarLeftComponent.propDecorators;
/** @type {?} */
SidebarLeftComponent.prototype.menu;
/** @type {?} */
SidebarLeftComponent.prototype.sidebarStyles;
/** @type {?} */
SidebarLeftComponent.prototype.sidebarHeight;
/** @type {?} */
SidebarLeftComponent.prototype.sidebarOverflow;
/** @type {?} */
SidebarLeftComponent.prototype.layout;
/** @type {?} */
SidebarLeftComponent.prototype.isSidebarLeftCollapsed;
/** @type {?} */
SidebarLeftComponent.prototype.isSidebarLeftExpandOnOver;
/** @type {?} */
SidebarLeftComponent.prototype.isSidebarLeftMouseOver;
/** @type {?} */
SidebarLeftComponent.prototype.windowInnerWidth;
/** @type {?} */
SidebarLeftComponent.prototype.windowInnerHeight;
/** @type {?} */
SidebarLeftComponent.prototype.collapsedItems;
/** @type {?} */
SidebarLeftComponent.prototype.activatedItems;
/** @type {?} */
SidebarLeftComponent.prototype.toggleListeners;
/** @type {?} */
SidebarLeftComponent.prototype.itemsByIds;
/** @type {?} */
SidebarLeftComponent.prototype.runningAnimations;
/** @type {?} */
SidebarLeftComponent.prototype.sidebarElement;
/** @type {?} */
SidebarLeftComponent.prototype.sidebarLeftToggleDirectives;
/** @type {?} */
SidebarLeftComponent.prototype.changeDetectorRef;
/** @type {?} */
SidebarLeftComponent.prototype.layoutStore;
/** @type {?} */
SidebarLeftComponent.prototype.ngZone;
/** @type {?} */
SidebarLeftComponent.prototype.renderer2;
/** @type {?} */
SidebarLeftComponent.prototype.router;
/** @type {?} */
SidebarLeftComponent.prototype.wrapperService;
/** @type {?} */
SidebarLeftComponent.prototype.headerService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
